import { services } from '@/data/services'
import { blogPosts } from '@/data/blogPosts'

export interface SearchResult {
  id: string
  title: string
  description: string
  url: string
  type: string
}

export function getSearchIndex(): SearchResult[] {
  const serviceResults: SearchResult[] = services.map(s => ({
    id: `service-${s.id}`,
    title: s.title,
    description: s.shortDescription,
    url: `/servicos/${s.slug}`,
    type: 'Serviço',
  }))

  const blogResults: SearchResult[] = blogPosts.map(b => ({
    id: `blog-${b.id}`,
    title: b.title,
    description: b.excerpt,
    url: `/blog/${b.slug}`,
    type: 'Blog',
  }))

  return [...serviceResults, ...blogResults]
}

export function searchContent(query: string): SearchResult[] {
  const normalized = query.trim().toLowerCase()
  if (!normalized)
    return []

  return getSearchIndex().filter(item =>
    item.title.toLowerCase().includes(normalized) || item.description.toLowerCase().includes(normalized),
  )
}
